export const JobsTop = {
    text:
        'Naast dat wij altijd op zoek zijn naar goede developers, hebben wij op dit moment ook de volgende vacatures uit staan:',
};
